import { usePartner } from 'components/app/routes/usePartner';
import { NsAlert } from 'components/common/ns-alert/NsAlert';
import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';
import { actionUrl } from 'config/static-content';
import { beforeUnloadHandler } from 'hooks/useBeforeUnload';

export const testId = 'sessionErrorTestId';

type SessionErrorProps = {
  message?: string;
  title?: string;
};

export const SessionError = ({ message, title }: SessionErrorProps) => {
  const { isDSJourney } = usePartner();

  const handleBackToQuote = () => {
    window.removeEventListener('beforeunload', beforeUnloadHandler);
    window.onbeforeunload = null;
    window.location.reload();
  };

  return (
    <NsAlert state="error" heading={title} testId={testId}>
      <p>{message}</p>
      {isDSJourney ? (
        <NsSecondaryCta onClick={handleBackToQuote}>
          Back to get a quote
        </NsSecondaryCta>
      ) : (
        <NsSecondaryCta href={actionUrl.bgHome} target="_self">
          Go to homepage
        </NsSecondaryCta>
      )}
    </NsAlert>
  );
};
